import BusinessSerializeSelector from "@/components/BusinessSerializeSelector";
import { userRole } from "@/constant/userRole";
import { useGetAllBusinessQuery } from "@/redux/api/businessApi";
import { useGetAllSiteLocationQuery } from "@/redux/api/siteLocationApi";
import { tabProps } from "@/utils/globalPropsTypes";
import { Checkbox, Form, Input, InputNumber, Select } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const getEntityIds = (val) => {
  if (!val) return undefined;
  if (typeof val === "string") return val;
  if (Array.isArray(val)) {
    const ids = val.map((item) => (typeof item === "object" ? item?._id || item?.id : item)).filter(Boolean);
    if (ids.length === 0) return undefined;
    return ids.length === 1 ? ids[0] : ids;
  }
  if (typeof val === "object") return val._id || val.id;
  return undefined;
};

function DataTab({ form, editItem, data: dashboardData = {} }) {
  const { component, counterDataType } = editItem;
  const userDetails = useSelector((state) => state?.user?.userDetails);

  const selectedBusiness = Form.useWatch("business", form) || editItem?.business;
  const busParamId = getEntityIds(dashboardData?.business);
  const siteParamId = getEntityIds(dashboardData?.site);

  const { data: businessList = {}, isFetching: businessLoading } = useGetAllBusinessQuery({
    limit: 500,
    page: 1,
    ...(busParamId ? { _id: busParamId } : {}),
  });

  const { data: siteList = {}, isFetching: siteLoading } = useGetAllSiteLocationQuery(
    {
      limit: 10000,
      page: 1,
      business: selectedBusiness,
      businesses: selectedBusiness,
      ...(siteParamId ? { _id: siteParamId } : {}),
    },
    { skip: !selectedBusiness },
  );

  useEffect(() => {
    if (component === "alarmNotification" && businessList?.data?.length === 1) {
      const singleId = businessList.data[0]._id;
      if (form.getFieldValue("business") !== singleId) {
        form.setFieldValue("business", singleId);
      }
    }
  }, [businessList, component]);

  return (
    <>
      {component === "alarmNotification" ? (
        <>
          <Form.Item
            name="business"
            label="Business"
            rules={[{ required: true, message: "Please select business" }]}
          >
            <Select
              placeholder="Select Business"
              allowClear={businessList?.data?.length !== 1}
              disabled={businessList?.data?.length === 1}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={
                businessList?.data?.map((b) => ({
                  label: b.name,
                  value: b._id,
                })) || []
              }
              onChange={() => {
                form.setFieldValue("site", undefined);
              }}
              loading={businessLoading}
            />
          </Form.Item>

          <Form.Item name="site" label="Site Location">
            <Select
              placeholder="Select Site Location"
              allowClear
              mode="multiple"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              maxTagCount="responsive"
              options={
                siteList?.data?.map((s) => ({
                  label: s.name,
                  value: s._id,
                })) || []
              }
              loading={siteLoading}
            />
          </Form.Item>

          <Form.Item
            name="notificationTypes"
            label="Notification Type"
            initialValue={["offlineDevice", "alarm"]}
            rules={[{ required: true, message: "Please select at least one notification type" }]}
          >
            <Checkbox.Group
              options={[
                { label: "Device Offline", value: "offlineDevice" },
                { label: "Alarm Triggered", value: "alarm" },
              ]}
            />
          </Form.Item>

          <Form.Item
            name="notificationLimit"
            label="No of Notifications"
            initialValue={5}
            rules={[{ required: true, message: "Please select display total" }]}
          >
            <Select
              placeholder="Select Display Total"
              options={[
                { label: "1", value: 1 },
                { label: "2", value: 2 },
                { label: "3", value: 3 },
                { label: "4", value: 4 },
                { label: "5", value: 5 },
                { label: "6", value: 6 },
                { label: "7", value: 7 },
                { label: "8", value: 8 },
                { label: "9", value: 9 },
                { label: "10", value: 10 },
              ]}
            />
          </Form.Item>
        </>
      ) : ["counter", "splitCounter"].includes(component) && counterDataType === "custom" ? (
        <>
          <Form.Item name="counterValue" label="Select Counter Value">
            <InputNumber className="w-100" placeholder="Enter Custom Value" />
          </Form.Item>
          <Form.Item name="counterUnit" label="Select Counter Unit">
            <Input className="w-100" placeholder="Enter Custom Unit" />
          </Form.Item>
        </>
      ) : ["comboBar"].includes(component) ? (
        <>
          <div>
            <div className="mb-2 fw-bold"> Line Chart: </div>
            {/* 
            <Form.List name={["comboLocations", "line"]} initialValue={[{}]}>
              {(fields) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <div key={key}> */}
            <BusinessSerializeSelector
              {...{
                form,
                // names: [name],
                names: ["comboLocations", "line"],
                business: {
                  params: { _id: dashboardData?.business },
                  isMulti: userDetails?.role === userRole.superAdmin,
                },
                site: { isMulti: true, params: { _id: dashboardData?.site } },
                device: {
                  isMulti:
                    component &&
                    !["dynamicBox", "tank", "counter", "splitCounter", "dial", "thermometer"].includes(component),
                },
                parameter: {
                  isMulti:
                    component &&
                    !["dynamicBox", "tank", "counter", "splitCounter", "dial", "thermometer"].includes(component),
                },
              }}
            />
            {/* </div>
                  ))}
                </>
              )}
            </Form.List>
             */}
          </div>

          <div className="mt-5">
            <div className="mb-2 fw-bold"> Bar Chart: </div>
            {/* <Form.List name={["comboLocations", "bar"]} initialValue={[{}]}>
              {(fields) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <div key={key}> */}
            <BusinessSerializeSelector
              {...{
                form,
                // names: [name],
                names: ["comboLocations", "bar"],
                business: {
                  params: { _id: dashboardData?.business },
                  isMulti: userDetails?.role === userRole.superAdmin,
                },
                site: { isMulti: true, params: { _id: dashboardData?.site } },
                device: {
                  isMulti:
                    component &&
                    !["dynamicBox", "tank", "counter", "splitCounter", "dial", "thermometer"].includes(component),
                },
                parameter: {
                  isMulti:
                    component &&
                    !["dynamicBox", "tank", "counter", "splitCounter", "dial", "thermometer"].includes(component),
                },
              }}
            />
            {/* </div>
                  ))}
                </>
              )}
            </Form.List> */}
          </div>
        </>
      ) : (
        // <Form.List name="locations" initialValue={[{}]}>
        //   {(fields) => (
        //     <>
        //       {fields.map(({ key, ...restField }) => (
        //         <div key={key}>

        <BusinessSerializeSelector
          {...{
            form,
            names: ["locations"],
            // listName: ["locations"],
            business: {
              formItemProps: {},
              params: { _id: busParamId },
              isMulti: userDetails?.role === userRole.superAdmin || (Array.isArray(busParamId) && busParamId.length > 1),
            },
            site: { formItemProps: {}, isMulti: true, params: { _id: siteParamId } },
            device: {
              formItemProps: {},
              isMulti:
                component &&
                !["dynamicBox", "loadSummary", "tank", "counter", "splitCounter", "dial", "thermometer"].includes(component),
            },
            parameter: {
              formItemProps: {},
              isMulti:
                component &&
                !["dynamicBox", "loadSummary", "tank", "counter", "splitCounter", "dial", "thermometer"].includes(component),
            },
          }}
        />
        //         </div>
        //       ))}
        //     </>
        //   )}
        // </Form.List>
      )}

      {["dial"].includes(component) && (
        <Form.Item name="unit" label="Enter Unit">
          <Input className="w-100" placeholder="Enter Unit" />
        </Form.Item>
      )}
    </>
  );
}

export default DataTab;

DataTab.propTypes = tabProps;
